import { useEffect } from "react"
import { useLocation, useParams } from "react-router-dom"
import {
  LOGIN_BACKUP,
  LOGIN_INTERNO_BACKUP,
} from "../../../../routes/RoutePaths"

const LoginToken = () => {
  const params = useParams()
  const location = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const TOKEN = searchParams.get("access_token")
    const isUserInterno = sessionStorage.getItem("session_type") === "0"

    if (TOKEN) {
      sessionStorage.setItem("access_token", TOKEN)
    }

    window.location.href = isUserInterno ? LOGIN_INTERNO_BACKUP : LOGIN_BACKUP
  }, [params, location])

  return <div />
}

export default LoginToken
